<template>
  <div class="order">
    <div class="order-task">
      <div
        v-for="(item, index) in taskList"
        :key="index"
        class="task-one"
        :class="item.process ? 'finished' : index === 2 ? 'ing' : ''"
      >
        {{ index + 1 }}. {{ item.nameEn }}
        <div class="box">
          <div v-if="!item.process"></div>
          <i v-else class="icon iconfont icon-duigou" style="color: #fff"></i>
        </div>
      </div>
      <!-- <div class="task-one">
        Done
        <div class="box"><div></div></div>
      </div> -->
      <div class="line"></div>
    </div>
    <div class="order-header">
      <p>Exhibition Application/参展申请</p>
      <span></span>
      <p>Select Order/展位信息</p>
    </div>

    <!-- 展区 -->
    <!-- <pre class="info-side">
      {{ JSON.stringify(selectInfo, null, 4) }}
    </pre> -->
    <div class="order-exhall">
      <p class="exhall-header" v-if="orderInfo">
        Please select an exhibition area/请选择您要参展的展区
      </p>
      <div class="exhall-list">
        <template v-if="list && list.length > 0">
          <div
            class="list-one"
            v-for="(item, index) in list"
            :key="index"
            @click="selectHandle(item)"
            :class="selectItem.id === item.id ? 'selected' : ''"
          >
            {{ item.name }}
          </div>
        </template>
        <div v-else style="width: 100%; line-height: 200px; text-align: center">
          no data！
        </div>
      </div>
      <p class="exhall-header" v-if="orderInfo">
        Please select booth type/请选择展位类型
      </p>
      <div class="booth-list">
        <template v-if="boothList && boothList.length">
          <div
            class="booth-one"
            :class="
              chooseBooth && chooseBooth.id === item.id ? 'chooseboothOne' : ''
            "
            v-for="(item, index) in boothList"
            :key="index"
            v-if="item.isEnable"
            @click="choose(item)"
          >
            <div class="f">
              <p :title="item.name">{{ item.name }}</p>
              <p :title="item.remark">{{ item.remark }}</p>
            </div>
            <div class="s">
              <!-- <p>媒体推广费 RMB 3400.00</p> -->
              <p></p>
              <p v-if="orderInfo && orderInfo.isAgent === '否'">
                {{ item.price }}{{ item.currencyKind }}/{{ item.unit }}
              </p>
            </div>
            <div class="t">
              Width/面宽：<InputNumber
                :max="999999999"
                :min="0"
                v-model="item.width1"
                @on-change="(v) => changeWidth1(v, index)"
              ></InputNumber>
              × Depth/进深：<InputNumber
                :max="999999999"
                :min="0"
                v-model="item.width2"
                @on-change="(v) => changeWidth2(v, index)"
                >></InputNumber
              >
              = {{ item.width1 * item.width2 }} ㎡
            </div>
            <div class="l" v-if="orderInfo && orderInfo.isAgent === '否'">
              <span v-if="item.boothArea > 1"
                >Total：{{
                  (
                    (item.width1 * item.width2 * item.price) /
                    item.boothArea
                  ).toFixed()
                }}{{ item.currencyKind }}</span
              >
              <span v-else
                >Total：{{ item.width1 * item.width2 * item.price }}
                {{ item.currencyKind }}</span
              >
            </div>
            <div
              class="choose"
              :class="
                chooseBooth && chooseBooth.id === item.id ? 'choosed' : ''
              "
            >
              <i class="icon iconfont icon-duigou"></i>
            </div>
          </div>
        </template>
        <div v-else style="width: 100%; line-height: 200px; text-align: center">
          No data！
        </div>
      </div>
      <!-- <div class="total">
        Total: <span> {{ totalNum }} </span>
        <template v-if="currency">{{ currency }}</template>
        <template v-else-if="selectInfo">{{ selectInfo.pType }}</template>
        <template v-else>RMB</template>
      </div> -->

      <div class="info">
        <div class="info-title">Fill in the remarks and instructions:</div>
        <ul>
          <li>
            Raw Space: In principle, the minimum rent is more than 36 square
            meters, excluding any other items, and exhibitors must find a booth
            builder by themselves.
          </li>
          <li>
            Standard booth: The standard booth is built for the conference, the
            booth size is 3m x 3m, including two spotlights, a 220V/5A power
            socket, a consultation table, two folding chairs, and carpets.
          </li>
          <li>
            Booth allocation will be made according to the "first come, first
            served" principle, according to the predetermined area size and
            payment order.
          </li>
          <li>
            The organizing committee prohibits two or more companies from
            sharing a standard booth, and it is strictly forbidden to resell the
            booth.
          </li>
          <li>
            Exhibitors shall be responsible for the legality of their own
            enterprises and exhibited products. Enterprises not in this industry
            are not allowed to participate in the exhibition.
          </li>
          <li>
            The final interpretation right belongs to the organizing committee.
          </li>
        </ul>
      </div>
    </div>
    <div class="order-btn">
      <Button
        type="primary"
        size="large"
        @click="goBack"
        style="margin-right: 30px"
        >Previous/上一步</Button
      >
      <Button
        type="primary"
        size="large"
        @click="goNext"
        :loading="loading"
        style="width: 300px"
        >Save and Proceed/保存并下一步</Button
      >
    </div>

    <iModal
      cancel-text
      width="420"
      v-model="isChange"
      :closable="false"
      :footer-hide="true"
    >
      <div class="change-modal">
        <div class="change-modal-top">
          <Icon type="ios-alert" color="#f90" size="28" />
          <p>确认</p>
        </div>
        <div class="change-modal-bottom">
          <p v-if="chooseBooth">
            您确定要放弃订购{{ chooseBooth.pjName }}展位吗 ？
          </p>
        </div>
        <div class="change-modal-btn">
          <Button
            type="text"
            @click="
              isChange = false;
              middleInfo = null;
            "
          >
            取消
          </Button>
          <Button type="primary" @click="confirm()" style="margin-left: 10px"
            >确定</Button
          >
        </div>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "order",
  data() {
    return {
      checkList: [],
      taskList: [],
      lastInfo: null, // 上次提交的信息
      loading: false,
      list: [],
      boothList: [],
      chooseBooth: null,
      otherList: [], // 线上增值服务
      otherList2: [], // 线下增值服务
      otherList3: [],
      chooseOtherArr: [], // 选中的增值服务
      isAllChoose: [], // 是否全选
      orderInfo: null,
      isChange: false,
      middleInfo: null,
      otherTotalPrice: 0,
      onlineFile: null,
      offlineFile: null,
      ChooseCheck: false,
      join: false, //是否参加过
      fixedId: 0,
      gudingprice: 0,
      remark: "",
      selectType: "Raw Space",
      IsNeedActivity: "0",
      input1: 0,
      radio: "",
      currencyKind: "",
      selectItem: null, // 选中的展区
      selectInfo: null, // 选中的展位类型
      rowInfo: null, // 特装
      rowCount: 0,
      standInfo: [], // 标展
      standSelect: null, // 标展
      standIdArr: [], // 标展
      standCount: 0, // 非角位
      total: 0,
      totalNum: 0,
      selectedExhall: "",
    };
  },
  computed: {
    exhibitionId() {
      return this.$route.query.id;
    },
    currency() {
      return this.$route.query.currency || "RMB";
    },
    applyCompanyId() {
      return this.$route.query.applyCompanyId;
    },
    applyCompanyOrderId() {
      return this.$route.query.applyCompanyOrderId;
    },
    groupId() {
      return this.$route.query.groupId;
    },
  },
  watch: {
    rowInfo(val, oldVal) {
      this.changeTotalNum();
    },
    checkList(val, oldVal) {
      this.changeTotalNum();
    },
    rowCount(val, oldVal) {
      this.changeTotalNum();
    },
  },
  created() {
    this.currencyKind = this.currency;
    this.init();
  },
  methods: {
    ...mapActions({
      getApplyFlow: "commonFill/getApplyFlow",
      getApplyFlowSpeed: "commonFill/getApplyFlowSpeed",
      getDePjNameGroup: "commonFill/getDePjNameGroup",
      addApplyOrder: "commonFill/addApplyOrder",
      getOrderDetail: "commonFill/getOrderDetail",
      editApplyOrder: "commonFill/editApplyOrder",
      getDeTerm: "commonFill/getDeTerm",
      getGroupInfoById: "commonFill/getGroupInfoById",
      getFile: "commonFill/getFile",
      getjoin: "commonFill/getjoin",

      getAllArea: "getAllArea", //获取展区列表
      getCommodities: "getCommodities", //获取商品信息
    }),
    changeTotalNum() {
      let num = 0;
      if (this.selectInfo && this.selectInfo.boothType === "Raw Space") {
        if (!this.rowCount) {
          this.totalNum = 0;
          return;
        }
        num =
          (this.rowCount / Number(this.selectInfo.standstall)) *
          this.selectInfo.price;
      } else {
        if (!this.checkList.length) {
          this.totalNum = 0;
          return 0;
        } else {
          this.checkList.forEach((c) => {
            num += c.myCount * c.price;
          });
        }
      }
      num = Number(num.toString().match(/^\d+(?:\.\d{0,2})?/));
      this.totalNum = num;
    },
    async init() {
      // 流程
      let taskList = await this.getApplyFlow();
      this.taskList = taskList;
      let info = await this.getApplyFlowSpeed(this.applyCompanyId);
      console.log("getApplyFlowSpeed", info); // 上一次提交的信息

      if (info && info.info) {
        this.lastInfo = info.info;
        if (this.taskList && this.taskList.length > 0) {
          this.taskList.map((c) => {
            if (this.lastInfo && this.lastInfo.speed >= c.speed) {
              c.process = true;
            }
          });
        }
      }

      if (!this.lastInfo) {
        // 没有报名信息跳出当前页
        if (this.applyCompanyOrderId) {
          this.$router.push(
            "/fillEn/join/basicEn?applyCompanyId=" +
              this.applyCompanyId +
              "&applyCompanyOrderId=" +
              this.applyCompanyOrderId
          );
        } else {
          this.$router.push(
            "/fillEn/join/basicEn?applyCompanyId=" + this.applyCompanyId
          );
        }
        return;
      }

      // 订单信息
      let orderInfo = await this.getOrderDetail(this.applyCompanyOrderId);
      this.orderInfo = orderInfo;
      console.log("orderInfo", this.orderInfo);

      if (this.orderInfo.isAgent === "否") {
        // 展位、增值服务
        let lists = await this.getAllArea(this.exhibitionId); // 是：展区选择展位； 否：增值服务项目
        lists = lists.filter((c) => {
          return c.languageType === "英文" && c.isEnable;
        });

        this.selectItem = lists[0];

        // }
        this.list = lists;

        let areaId = lists[0].id;
        if (this.orderInfo) {
          if (this.orderInfo.applyBoothOrderList.length > 0) {
            areaId = this.orderInfo.applyBoothOrderList[0].dePjNameGroupId;
          }
        }
        this.boothList = await this.getCommodities({
          exhibitionId: this.exhibitionId,
          currencyKind: this.currencyKind == "RMB" ? "￥" : "$",
          areaId: areaId,
          isEnable: true,
        });
        this.boothList.map((c) => {
          c.width1 = 0;
          c.width2 = 0;
        });
        this.selectItem = lists[0];
        this.selectedExhall = lists[0];
        //如果有订单默认选中
        if (
          this.orderInfo &&
          this.orderInfo.applyBoothOrderList.length &&
          lists
        ) {
          lists.forEach((c) => {
            if (c.id == this.orderInfo.applyBoothOrderList[0].dePjNameGroupId) {
              this.selectItem = c;
              this.selectedExhall = c;
              console.log(this.selectedExhall, "这个是选中的数据");
              //   if (this.selectedExhall.name.indexOf('其他') != -1) {
              //       this.inputShow = true
              //       this.remark = orderInfo.remark
              //   }
            }

            this.boothList.map((c) => {
              if (
                this.orderInfo &&
                this.orderInfo.applyBoothOrderList.length &&
                lists
              ) {
                if (c.name == this.orderInfo.applyBoothOrderList[0].name) {
                  //   this.boothList = c.dePjNameLis
                  this.chooseBooth = c;
                  if (this.chooseBooth) {
                    this.chooseBooth.width1 =
                      this.orderInfo.applyBoothOrderList[0].width;
                    this.chooseBooth.width2 =
                      this.orderInfo.applyBoothOrderList[0].height;
                  }
                }
              }
            });
            console.log(this.boothList, 1111);
            //   线上/线下 市场增值服务项目回显
          });
        }
        return;
        // 展位、增值服务
        let list2 = await this.getDePjNameGroup({
          IsBoothGroup: "是",
          ExhibitionId: this.exhibitionId,
          TypeLanguage: "英文",
        }); // 是：展区选择展位； 否：增值服务项目
        let list = [];
        list2.forEach((c) => {
          let arr = [];
          c.dePjNameList.forEach((v) => {
            if (v.pType && this.currency && v.pType === this.currency) {
              // 过滤币种
              arr.push(v);
            }
          });
          list.push(Object.assign(c, { dePjNameList: arr }));
        });
        console.log("list2", list);
        if (list && list.length) {
          if (list[0].dePjNameList.length > 0) {
            this.boothList = list[0].dePjNameList;
            if (this.boothList.length > 0) {
              this.boothList.map((c) => {
                c.width1 = 0;
                c.width2 = 0;
              });
            }
          }
          this.selectItem = list[0];
          this.selectHandle(list[0]);
        }
        this.list = list;
        //如果有订单默认选中
        if (
          this.orderInfo &&
          this.orderInfo.applyBoothOrderList.length &&
          list.length
        ) {
          let applyBoothOrderInfo = this.orderInfo.applyBoothOrderList[0];
          list.forEach((c) => {
            if (c.id === applyBoothOrderInfo.dePjNameGroupId) {
              this.selectHandle(c);
              c.dePjNameList.forEach((e) => {
                this.orderInfo.applyBoothOrderList.forEach((i) => {
                  if (e.pjCode === i.pjCode) {
                    if (e.boothType === "Raw Space") {
                      this.selectInfo = e;
                      this.rowCount = i.area;
                    } else {
                      let count = i.area / Number(e.standstall);
                      this.checkList.push(Object.assign(e, { myCount: count }));
                    }
                  }
                });
              });
            }
          });
        }
        if (list.length && !this.selectItem) {
          this.selectHandle(list[0]);
        }
        console.log("list2", this.list);
      }
    },
    goBack() {
      this.$router.push(
        "/fillEn/join/entranceEn?applyCompanyId=" +
          this.applyCompanyId +
          "&applyCompanyOrderId=" +
          this.applyCompanyOrderId
      );
    },
    async goNext() {
      if (!this.selectItem) {
        this.$Message.warning(
          "Please select an exhibition area/请选择您要参展的展区"
        );
        return;
      }
      if (!this.selectedExhall && !this.selectedExhall.length) {
        this.$Message.warning("Please select booth type/请选择展位类型");
        return;
      }
      // if (this.selectInfo && this.selectInfo.boothType === "Raw Space") {
      //   let minCount =
      //     this.selectInfo.minCount * Number(this.selectInfo.standstall);
      //   if (this.rowCount < minCount) {
      //     this.$Message.warning(
      //       `Booth area should greater than ${minCount}/展位面积应大于${minCount}`
      //     );
      //     return;
      //   }
      // } else {
      //   let allCount = 0; // 标展总个数
      //   let milCount = 0; // 角位个数
      //   this.checkList.forEach((c) => {
      //     console.log(c, 1111);
      //     allCount += c.myCount;
      //     if (c.pjName.indexOf("Scheme-Corner") > -1) {
      //       // 判断是否是角位
      //       milCount += c.myCount;
      //     }
      //   });
      //   if (!allCount) {
      //     this.$Message.warning(`Please enter booth number/请输入展位数量`);
      //     return;
      //   }
      //   // 每家企业最多申请两个角位 / Each enterprise can apply for up to two corner booths
      //   if (milCount > 2) {
      //     this.$Message.warning(
      //       `每家企业最多申请两个角位 / Each enterprise can apply for up to two corner booths`
      //     );
      //     return;
      //   }
      //   // 4个展位以下，每家企业最多只能申请1个角位 / Within 4 booths, each enterprise can only apply for a maximum of 1 corner booth
      //   if (allCount <= 3 && milCount > 1) {
      //     this.$Message.warning(
      //       `4个展位以下，每家企业最多只能申请1个角位 / Within 4 booths, each enterprise can only apply for a maximum of 1 corner booth`
      //     );
      //     return;
      //   }
      // }
      // 上面为选择逻辑判断
      let orderList = [];
      // if (this.selectInfo) {
      //   // 特装
      //   console.log("this.selectInfo", this.selectInfo);
      //   let total =
      //     (this.rowCount / Number(this.selectInfo.standstall)) *
      //     this.selectInfo.price;
      //   total = Number(total.toString().match(/^\d+(?:\.\d{0,2})?/));
      //   let Area = this.rowCount;
      //   orderList.push({
      //     ApplyCompanyOrderId: this.applyCompanyOrderId,
      //     DePjNameGroupId: this.selectItem.id,
      //     DePjNameGroupName: this.selectItem.name,
      //     Name: this.selectInfo.pjName,
      //     Area: Area,
      //     Unit: this.selectInfo.cunit,
      //     UnitPrice: this.selectInfo.price,
      //     TotalPrice: total,
      //     MonetaryUnit: this.selectInfo.pType,
      //     IsAgent: "否",
      //     RexMoney: total,
      //     GpName: this.selectInfo.gpName || "",
      //     GpCode: this.selectInfo.gpCode || "",
      //     PjCode: this.selectInfo.pjCode || "",
      //     GroupId: this.selectInfo.groupId || "",
      //     PjFormat: this.selectInfo.pjFormat || "",
      //     BoothType: this.selectInfo.boothType || "",
      //   });
      // } else {
      //   // 标展
      //   console.log("this.checkList", this.checkList);
      //   this.checkList.forEach((c) => {
      //     let Area = c.myCount;
      //     Area = Number(c.standstall) * c.myCount;
      //     let total = c.myCount * c.price;
      //     total = Number(total.toString().match(/^\d+(?:\.\d{0,2})?/));
      //     orderList.push({
      //       ApplyCompanyOrderId: this.applyCompanyOrderId,
      //       DePjNameGroupId: this.selectItem.id,
      //       DePjNameGroupName: this.selectItem.name,
      //       Name: c.pjName,
      //       Area: Area,
      //       Unit: c.cunit,
      //       UnitPrice: c.price,
      //       TotalPrice: total,
      //       MonetaryUnit: c.pType,
      //       IsAgent: "否",
      //       RexMoney: total,
      //       GpName: c.gpName || "",
      //       GpCode: c.gpCode || "",
      //       PjCode: c.pjCode || "",
      //       GroupId: c.groupId || "",
      //       PjFormat: c.pjFormat || "",
      //       BoothType: c.boothType || "",
      //     });
      //   });
      // }

      let req = {
        Id: this.applyCompanyOrderId,
        ApplyCompanyId: this.applyCompanyId,
        ExhibitionId: this.exhibitionId,
        IsAgent: "否",
        Remark: this.remark,
        ApplyBoothOrderList: [
          {
            ApplyCompanyOrderId: this.applyCompanyOrderId,
            DePjNameGroupId: this.selectedExhall.id,
            DePjNameGroupName: this.selectedExhall.name,
            ThirdPartyCommodityId: this.chooseBooth.id,
            Name: this.chooseBooth.name,
            Width: this.chooseBooth.width1,
            Height: this.chooseBooth.width2,
            Area: this.chooseBooth.width1 * this.chooseBooth.width2,
            Unit: this.chooseBooth.unit,
            UnitPrice: this.chooseBooth.price,
            TotalPrice:
              this.chooseBooth.width1 *
              this.chooseBooth.width2 *
              this.chooseBooth.price,
            MonetaryUnit: this.chooseBooth.currencyKind,
            IsAgent: "否",
            Rex: 1,
            RexMoney:
              this.chooseBooth.width1 *
              this.chooseBooth.width2 *
              this.chooseBooth.price,
            GpName: this.chooseBooth.kindName,
            GpCode: "",
            GroupId: 1,
            PjCode: "",
            PjFormat: "",
            BoothType: this.chooseBooth.boothKind || "",
          },
        ],
      };
      if (this.chooseBooth.boothArea > 1) {
        req.ApplyBoothOrderList[0].TotalPrice = (
          (this.chooseBooth.width1 *
            this.chooseBooth.width2 *
            this.chooseBooth.price) /
          parseInt(this.chooseBooth.boothArea)
        ).toFixed();

        req.ApplyBoothOrderList[0].RexMoney = (
          (this.chooseBooth.width1 *
            this.chooseBooth.width2 *
            this.chooseBooth.price) /
          parseInt(this.chooseBooth.boothArea)
        ).toFixed();
      }
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);

      if (this.lastInfo.speed < 3) {
        let info = await this.addApplyOrder(req);
        this.loading = false;
        if (info && info.successed) {
          this.$Message.success("Saved successfully！/保存成功！");
          if (this.groupId) {
            this.$router.push(
              "/fillEn/join/catalogueEn?id=" +
                this.exhibitionId +
                "&applyCompanyId=" +
                this.applyCompanyId +
                "&applyCompanyOrderId=" +
                this.applyCompanyOrderId +
                "&groupId=" +
                this.groupId +
                "&currency=" +
                this.currency
            );
          } else {
            this.$router.push(
              "/fillEn/join/catalogueEn?id=" +
                this.exhibitionId +
                "&applyCompanyId=" +
                this.applyCompanyId +
                "&applyCompanyOrderId=" +
                this.applyCompanyOrderId +
                "&currency=" +
                this.currency
            );
          }
        }
      } else {
        let info = await this.editApplyOrder(req);
        this.loading = false;
        if (info && info.successed) {
          this.$Message.success("Modification succeeded！/修改成功！");
          if (this.groupId) {
            this.$router.push(
              "/fillEn/join/catalogueEn?id=" +
                this.exhibitionId +
                "&applyCompanyId=" +
                this.applyCompanyId +
                "&applyCompanyOrderId=" +
                this.applyCompanyOrderId +
                "&groupId=" +
                this.groupId +
                "&currency=" +
                this.currency
            );
          } else {
            this.$router.push(
              "/fillEn/join/catalogueEn?id=" +
                this.exhibitionId +
                "&applyCompanyId=" +
                this.applyCompanyId +
                "&applyCompanyOrderId=" +
                this.applyCompanyOrderId +
                "&currency=" +
                this.currency
            );
          }
        }
      }
    },
    async selectHandle(e) {
      this.selectItem = e;
      this.selectedExhall = e;
      // 重复利用的接口
      this.boothList = await this.getCommodities({
        exhibitionId: this.exhibitionId,
        currencyKind: this.currencyKind == "RMB" ? "￥" : "$",
        areaId: e.id,
        isEnable: true,
        //   groupType: ['固定费用', '线上','线下']
      });
      this.boothList.map((c) => {
        c.width1 = 0;
        c.width2 = 0;
      });
      return;
      if (!e) return;
      if (this.checkList) {
        this.checkList.map((c) => {
          c.myCount = 0;
        });
      }
      this.totalNum = 0;
      this.checkList = [];
      this.rowCount = 0;
      this.selectItem = e;
      this.selectInfo = null;
      this.rowInfo = null;
      this.standInfo = [];
      this.standIdArr = [];
      console.log("selectItem", e);
      if (!e.dePjNameList.length) return;
      e.dePjNameList.map((c) => {
        if (c.boothType === "Raw Space") {
          this.rowInfo = c;
        } else {
          c.myCount = 0;
          this.standInfo.push(c);
          this.standIdArr.push(c.id);
        }
      });
      console.log("rowInfo", this.rowInfo);
      console.log("standInfo", this.standInfo);
    },
    confirm() {
      this.isChange = false;
      this.selectItem = this.middleInfo;
      if (this.middleInfo.dePjNameList.length > 0) {
        this.middleInfo.dePjNameList.map((c) => {
          c.width1 = 0;
          c.width2 = 0;
        });
      }
      this.boothList = this.middleInfo.dePjNameList;
      this.chooseBooth = null;
    },
    ItemChange() {
      if (this.checkList.length) return;
      this.selectInfo = null;
      this.rowCount = 0;
      this.checkList.push(this.standInfo[0]);
    },
    standClick() {
      this.selectInfo = null;
      this.rowCount = 0;
    },
    rowClick() {
      this.checkList.map((c) => {
        c.myCount = 0;
      });
      this.totalNum = 0;
      this.checkList = [];
      this.selectInfo = this.rowInfo;
    },
    choose(e) {
      this.chooseBooth = e;
      console.log(e, "eeeeeeeeeee");
    },
    changeWidth1(e, i) {
      this.$set(this.boothList, i, this.boothList[i]);
    },
    changeWidth2(e, i) {
      this.$set(this.boothList, i, this.boothList[i]);
    },
  },
};
</script>

<style scoped lang="scss">
.order {
  &-task {
    width: 100%;
    margin: 20px 0 50px;
    padding: 0 80px;
    display: flex;
    justify-content: space-between;
    color: #666;
    position: relative;

    .task-one {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 2;

      .box {
        width: 20px;
        height: 20px;
        background-color: #fff;
        box-shadow: 0px 2px 5px 0px rgba(1, 53, 97, 0.5);
        border-radius: 50%;
        margin-top: 10px;

        div {
          width: 14px;
          height: 14px;
          background-color: #8ba5bc;
          border-radius: 50%;
          margin: 3px auto 0;
        }
      }
    }

    .line {
      height: 8px;
      background-color: #d7dee4;
      position: absolute;
      width: 949px;
      left: 151px;
      top: 37px;
      z-index: 1;
    }

    .ing {
      color: rgba(0, 161, 233, 1);

      .box {
        div {
          background-color: rgba(0, 161, 233, 1);
        }
      }
    }

    .finished {
      color: rgba(0, 161, 233, 1);

      .box {
        background-color: rgba(0, 161, 233, 1);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-color: rgba(0, 161, 233, 1);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 64px;
      font-size: 20px;
    }

    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-exhall {
    padding: 30px;
    background-color: #fff;

    .exhall-header {
      width: 100%;
      height: 46px;
      background-color: #e6eef7;
      color: #333;
      font-size: 18px;
      line-height: 46px;
      padding-left: 20px;
      font-weight: bold;
    }

    .exhall-list {
      display: flex;
      flex-wrap: wrap;
      padding: 20px 0 15px;
      background-color: #fff;

      .list-one {
        padding: 4px 20px;
        border: solid 1px #e3e3e3;
        margin: 0 15px 15px 0;
        border-radius: 5px;
        cursor: pointer;
      }

      .selected {
        background-color: #00a1e9;
        border: solid 1px #00a1e9;
        color: #fff;
      }
    }

    .booth-list {
      background-color: #fff;
      margin-bottom: 30px;
      overflow: hidden;

      &-top {
        margin-top: 40px;
        width: 100%;
        line-height: 64px;
        text-align: center;
        font-size: 20px;
        color: #666;
        border-radius: 10px 10px 0px 0px;
        display: flex;
        justify-content: space-between;

        .top-item {
          height: 64px;
          border-radius: 10px 10px 0px 0px;
          background-color: #f7f7f7;
          width: calc(50% - 10px);
          cursor: pointer;

          &.active {
            color: #fff;
            background-color: rgba(0, 161, 233, 1);
          }
        }
      }

      &-content {
        border: solid 1px rgba(0, 161, 233, 1);
        padding: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }

      &-bottom {
        width: 100%;
        position: relative;
        border: solid 1px rgba(0, 161, 233, 1);
        border-top-color: transparent;
        border-radius: 0px 0px 10px 10px;
        background-color: #f7f7f7;
        padding: 20px;

        .bottom-select {
          font-size: 16px;
          color: #333;
          margin-bottom: 10px;
        }

        .bottom-txt {
          font-size: 12px;
          color: #666;
        }
      }
    }
  }

  &-other {
    background-color: #fff;
    padding: 0 30px 30px;

    .other-header {
      width: 100%;
      height: 46px;
      background-color: #e6eef7;
      color: #333;
      font-size: 18px;
      line-height: 46px;
      padding-left: 20px;
      font-weight: bold;
    }

    .other-online {
      padding: 0 30px;
      margin-bottom: 30px;
      font-size: 16px;

      a {
        text-decoration: underline;
      }
    }

    .other-list {
      width: 1080px;
      margin: 0 auto 30px;
      border: solid 1px #e5e5e5;

      .top {
        background-color: #f5f5f5;
        height: 46px;
        line-height: 46px;
        position: relative;
        padding: 0 20px;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333;
        border-bottom: 1px solid #e5e5e5;

        .r {
          cursor: pointer;
          display: flex;
          align-items: center;

          i {
            font-size: 20px;
            margin-left: 5px;
          }
        }
      }

      .content {
        padding: 20px 20px 0 20px;

        .content-one {
          width: 100%;
          margin: 0 auto 20px;
          border: 1px solid #e5e5e5;

          .title {
            width: 100%;
            height: 46px;
            background-color: #f5f5f5;
            line-height: 46px;
            font-size: 16px;
            color: #333;
            padding-left: 20px;
            border-bottom: 1px solid #e5e5e5;
          }

          .details {
            width: 100%;
            height: 230px;
            display: flex;

            .text {
              width: 50%;
              height: 100%;
              padding: 0 30px;
              position: relative;
              cursor: pointer;
              color: #333;
              font-size: 16px;

              .time {
                width: 100%;
                display: flex;
                align-items: center;
                margin-top: 20px;

                span {
                  width: 100px;
                }
              }

              .choose {
                position: absolute;
                right: 0;
                bottom: 0;
                width: 0;
                height: 0;
                border-bottom: 46px solid #d9d9d9;
                border-left: 46px solid transparent;

                i {
                  position: absolute;
                  top: 10px;
                  left: -30px;
                  color: #fff;
                  font-size: 30px;
                }
              }

              .choosed {
                border-bottom: 46px solid #00a1e9;
              }
            }

            img {
              width: 50%;
              height: 100%;
            }
          }
        }
      }
    }

    .total {
      width: 100%;
      min-height: 173px;
      background-color: #f5f5f5;
      border: solid 1px #e5e5e5;
      text-align: right;
      font-size: 16px;
      color: #333;
      padding: 30px;

      p {
        line-height: 1;
      }

      .red {
        color: #00a1e9;
      }
    }
  }

  &-btn {
    margin-top: 50px;
    padding-bottom: 80px;
    text-align: center;

    button {
      width: 200px;
      height: 48px;
      background-color: rgba(0, 161, 233, 1);
      font-size: 16px;
      border-color: rgba(0, 161, 233, 1);
    }
  }
}

.change-modal {
  padding: 6px 16px 8px;

  &-top {
    display: flex;
    align-items: center;

    p {
      padding-left: 12px;
      color: #17233d;
      font-size: 16px;
      line-height: 42px;
    }
  }

  &-bottom {
    margin-left: 40px;
  }

  &-btn {
    text-align: right;
    margin-top: 20px;
  }
}

.table {
  display: table;
  margin: 5px;

  .row {
    display: table-row;
  }

  .cell {
    display: table-cell;
    padding: 5px;

    &.f-tal {
      width: 100px;
    }
  }
}

.booth-box {
  padding-top: 20px;

  .item {
    min-height: 255px;
    background-color: #f5f5f5;
    margin-bottom: 20px;
    padding: 20px 20px 0;
    padding-bottom: 20px;
    position: relative;
    cursor: pointer;
    border-radius: 4px;

    &::after {
      content: "Not selected";
      background-color: rgb(151, 151, 151);
      color: #fff;
      font-size: 18px;
      line-height: 2.5;
      padding: 0 20px;
      text-align: center;
      position: absolute;
      top: 0;
      right: 0;
      border-bottom-left-radius: 10px;
      border-top-right-radius: 4px;
    }

    &.select {
      background-color: #d7ecf6;

      &::after {
        content: "Selected";
        background-color: #00a1e9;
      }
    }

    h4 {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-size: 20px;
      color: #333;
      font-weight: normal;
      margin-bottom: 20px;
    }

    .txt1 {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-size: 16px;
      color: #333;
      margin-bottom: 20px;
      height: 52px;
    }

    .line {
      font-size: 14px;
      margin-bottom: 10px;

      .unit {
        display: inline-block;
        margin-left: 10px;
      }
    }

    .tip {
      line-height: 1;
      font-size: 12px;
      color: rgb(128, 128, 128);
      margin-top: 6px;
    }
  }
}

.u-req {
  display: inline-block;

  &::before {
    content: "*";
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 14px;
    color: #ed4014;
  }
}

.total {
  background-color: #f5f5f5;
  line-height: 46px;
  padding: 0 20px;
  text-align: right;
  font-size: 16px;

  span {
    color: #ed4014;
    font-size: 20px;
    font-weight: 600;
  }
}

.info {
  padding: 20px 0 0 10px;

  &-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  ul {
  }

  li {
    margin-left: 20px;
    line-height: 1.8;
    list-style-type: disc;
  }
}

.info-side {
  position: fixed;
  top: 200px;
  left: 0;
  z-index: 99999999;
  background-color: #fff;
  width: 200px;
}
.booth-list {
  background-color: #fff;
  padding: 20px 0 10px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .booth-one {
    width: 560px;
    height: 230px;
    background-color: #f5f5f5;
    margin-bottom: 20px;
    padding: 20px;
    position: relative;
    cursor: pointer;

    .f {
      display: flex;
      justify-content: space-between;

      p {
        width: 90%;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        font-size: 20px;
        color: #333;
      }

      p:last-child {
        text-align: right;
        font-size: 14px;
      }
    }

    .s {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      p {
        width: 50%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 16px;
        color: #333;
      }

      p:last-child {
        text-align: right;
        font-size: 24px;
        color: rgba(0, 161, 233, 1);
      }
    }

    .t {
      margin-top: 10px;
      color: #333;
    }

    .l {
      color: #333;
      font-size: 16px;
      margin-top: 30px;
    }

    .choose {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 0;
      height: 0;
      border-bottom: 46px solid #d9d9d9;
      border-left: 46px solid transparent;

      i {
        position: absolute;
        top: 10px;
        left: -30px;
        color: #fff;
        font-size: 30px;
      }
    }

    .choosed {
      border-bottom: 46px solid rgba(0, 161, 233, 1);
    }
  }

  .chooseboothOne {
    border: 1px solid rgba(0, 161, 233, 1);
  }
}
</style>
